<script setup>
import CharacterJumpFromTheRight from '../text_animations/CharacterJumpFromTheRight.vue'
import CharacterEnlarge from '../text_animations/CharacterEnlarge.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  title: String,
  line: String,
})

const timelineTitle = ref(null)
const timelineLine = ref(null)

const contentElement = ref(null)

const emit = defineEmits(['timeline', 'timelineOut'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'TwoLineLowerThird' }).add(timelineTitle).add(timelineLine, '<.28')
  emit('timeline', timeline)

  const timelineOut = () => {
    timelineTitle.value.reverse()
    timelineLine.value.reverse()

    return gsapTimeline({ name: 'TwoLineLowerThird - End' }).add(timelineTitle).add(timelineLine, '<.24').endInvisible(contentElement)
  }
  emit('timelineOut', timelineOut)
})
</script>

<template>
  <div ref="contentElement" class="absolute bottom-0 p-safe -space-y-3">
    <CharacterJumpFromTheRight v-if="title" :text="title" class="text-q-cr-red-primary" @timeline="timelineTitle = $event" />
    <CharacterEnlarge v-if="line" :text="line" class="text-white font-cervo font-bold text-[85px]" @timeline="timelineLine = $event" />
  </div>
</template>
